import { useFormContext } from "@/app/components/formContext/formcontext";
import VehicleCard from "@/app/components/ServicesComponents/FrotistasCard";
import {
  CustomPaging,
  SampleNextArrow,
  SamplePrevArrow,
} from "@/app/components/swipersComponents";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { withServicesLayout } from "@/pages/_layoutService";

function Frotista() {
  const { setOptions, setInputValue } = useFormContext();
  const [currentIndex, setCurrentIndex] = useState(0);
  interface VehicleData {
    imageSrc: string;
    title: string;
    subtitle: string;
    features: string[];
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-frotista" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const vehiclesData: VehicleData[] = [
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Frotista/frota_corolla.png",
      title: "FROTA COROLLA",
      subtitle: "ALTIS HYBRIDO | 24/24",
      features: ["Consumo de ------", "Sistema Híbrido Flex", "Teto Solar"],
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Frotista/frota_hilux.png",
      title: "FROTA HILUX",
      subtitle: "STD POWER PACK 4X4 | 24/24",
      features: ["Consumo de -----", 'Sistema multimídia de 9"', "Tração 4x4"],
    },
  ];
  const models = [
    "Corolla - Altis Hybrid",
    "Hilux - STD Power Pack",
  ];

  useEffect(() => {
    setOptions([...models]);
  }, []);

  return (
    <>
      <div className="w-full text-zinc-800 p-3">
        <div className="w-full  h-36 mt-5 lg:p-3 ">
          <h1 className="text-[40px]  text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
            Frotista
          </h1>
          <div className="w-16 border-b-2 ml-1 border-red-600 " />
        </div>
        <p className="mt-10">
          A Venda Direta da Toyota oferece uma solução eficiente e personalizada
          para empresas que buscam renovar ou expandir sua frota de veículos. A
          Toyota é reconhecida mundialmente pela qualidade e confiabilidade de
          seus veículos. Nossos carros são projetados para proporcionar
          desempenho superior, economia de combustível e baixos custos de
          manutenção, garantindo que sua frota opere de forma eficiente e sem
          contratempos. Além de vantagens exclusivas, todos os modelos estão
          cobertos pela garantia de 10(dez) anos ou 100 mil quilômetros. Não perca
          mais tempo e leve sua frota para o próximo nível com a Toyota.
        </p>
        {/*<h2 className="text-2xl py-5">Nossos modelos:</h2>
        <div className="flex flex-col gap-5 max-lg:hidden">
          {vehiclesData.map((vehicle, index) => (
            <VehicleCard
              key={"cardVehicle.frotista" + index}
              imageSrc={vehicle.imageSrc}
              title={vehicle.title}
              subtitle={vehicle.subtitle}
              features={vehicle.features}
              onClick={() => {
                setInputValue(models[index]);
              }}
            />
          ))}
        </div>
        <div className="flex flex-col gap-5 lg:hidden mb-20">
          <Slider {...settings}>
            {vehiclesData.map((vehicle, index) => (
              <div key={`frotista-mobile-${vehicle.title}-${index}`}>
                <VehicleCard
                  key={`frotista-card-${vehicle.title}-${index}`}
                  imageSrc={vehicle.imageSrc}
                  title={vehicle.title}
                  subtitle={vehicle.subtitle}
                  features={vehicle.features}
                  onClick={() => {
                    setInputValue(models[index]);
                  }}
                />
              </div>
            ))}
          </Slider>
        </div>*/}
        <h2 className="text-2xl py-5">Documentações necessárias:</h2>
        <p className="pb-5">
          - Ficha cadastral de Empresário individual ou Contrato Social ou Ato
          Constitutivo;
          <br />
          - Ata de eleição da Diretoria e/ou Procuração se houver;
          <br />
          - RG/CPF ou documento equivalente do administrador ou representante
          legal da empresa;
          <br />
          - Cartão CNPJ (Situação Ativa);
          <br />- Inscrição Estadual (Situação Regular)
        </p>
      </div>
    </>
  );
}

export default withServicesLayout(Frotista);
export { getServerSideProps } from "@/pages/_layoutService";
